import { render } from "./QuienesSomos.vue?vue&type=template&id=5facc1ff"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\www\\m2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__